import React from 'react';
import styles from './Countdown.module.css';

function Pad(n) {
  return String(n).padStart(2, '0');
}

export function Countdown({ days, hours, minutes, seconds }) {
  const blocks = [
    { value: days,    label: 'Días' },
    { value: hours,   label: 'Horas' },
    { value: minutes, label: 'Minutos' },
    { value: seconds, label: 'Segundos' },
  ];

  return (
    <div className={styles.countdown} aria-label="Cuenta regresiva al lanzamiento">
      {blocks.map((b, i) => (
        <React.Fragment key={b.label}>
          {i > 0 && <span className={styles.sep} aria-hidden="true">:</span>}
          <div className={styles.block}>
            <span className={styles.num}>{Pad(b.value)}</span>
            <span className={styles.label}>{b.label}</span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}
